<template>
  <header>
    <div class="header pa-2 d-flex justify-space-between align-center">
      <div class="d-flex align-center">
        <Sidebar
          v-if="!studentRole"
          :isLoggedIn="isLoggedIn"
          :drawer="drawer"
          @modelValue="e => (drawer = e)"
        />

        <router-link
          :to="studentRole ? '/schedule' : '/'"
          class="d-flex align-center"
          style="text-decoration: none; color: black"
        >
          <img
            v-if="!isXs"
            alt="logo"
            src="@/assets/logo.png"
            class="logo mr-2"
          />
          <span
            class="header-text"
            :class="{ 'header-text-small': isXs }"
          >
            {{ $t('main.title') }}
          </span>
        </router-link>
      </div>

      <div class="text-end">
        <v-btn
          text
          @click="isOpenedInstructions = true"
          small
          >{{ $t('header.instructions') }}</v-btn
        >

        <v-btn
          icon
          outlined
          small
          @click="setLocale(isRU ? 'en' : 'ru')"
        >
          {{ isRU ? 'en' : 'ru' }}
        </v-btn>

        <v-menu
          v-if="isLoggedIn"
          offset-y
          v-model="openMenu"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              text
              v-on="on"
              color="grey"
              class="px-3 show-login-menu"
              small
              :title="userName"
            >
              <span class="lightGrey--text">{{ userName }}</span>
              <v-icon
                right
                class="lightGrey--text"
                >{{ openMenu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon
              >
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              dense
              @click="logout"
            >
              <v-list-item-title class="accent--text body-1 pointer">
                {{ $t('header.logout') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>

    <DialogModal
      :activator="isOpenedInstructions"
      @closeModal="isOpenedInstructions = false"
    >
      <template #content>
        <v-tabs v-model="tab">
          <v-tab>{{ $t('header.instructions') }}</v-tab>
          <v-tab v-if="editorScheduleRole || adminRole">{{ $t('header.templates') }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <div class="pa-2">
              <a
                :href="getActualUrl('/instructions_for_student.pdf')"
                download="инструкция_для_студента.pdf"
                class="mt-4 d-flex align-center file-link"
                @click.prevent="openInstructionsInNewTab('/instructions_for_student.pdf')"
              >
                <v-icon
                  size="18"
                  class="mr-1"
                  >mdi-link-variant</v-icon
                >
                <span>{{ $t('header.instructionsStudent') }}</span>
              </a>

              <a
                v-if="editorClassroomsRole || editorTeachersRole"
                :href="getActualUrl('/instructions_for_department.pdf')"
                download="инструкция_для_кафедры.pdf"
                class="mt-4 d-flex align-center file-link"
                @click.prevent="openInstructionsInNewTab('/instructions_for_department.pdf')"
              >
                <v-icon
                  size="18"
                  class="mr-1"
                  >mdi-link-variant</v-icon
                >
                <span>{{ $t('header.instructionsDepartment') }}</span>
              </a>

              <a
                v-if="adminRole"
                :href="getActualUrl('/instructions_for_administrator.pdf')"
                download="инструкция_для_администратора.pdf"
                class="mt-4 d-flex align-center file-link"
                @click.prevent="openInstructionsInNewTab('/instructions_for_administrator.pdf')"
              >
                <v-icon
                  size="18"
                  class="mr-1"
                  >mdi-link-variant</v-icon
                >
                <span>{{ $t('header.instructionsAdmin') }}</span>
              </a>
            </div>
          </v-tab-item>

          <v-tab-item>
            <div class="pa-2">
              <div class="pa-2">
                <a
                  :href="getActualUrl('/templates_type_1.xlsx')"
                  download="тип_1.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_1.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType1') }}</span>
                </a>

                <a
                  :href="getActualUrl('/templates_type_2.xlsx')"
                  download="тип_2.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_2.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType2') }}</span>
                </a>
                <a
                  :href="getActualUrl('/templates_type_3.xlsx')"
                  download="тип_3.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_3.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType3') }}</span>
                </a>
                <a
                  :href="getActualUrl('/templates_type_4.xlsx')"
                  download="тип_4.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_4.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType4') }}</span>
                </a>
                <a
                  :href="getActualUrl('/templates_type_5.xlsx')"
                  download="тип_5.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_5.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType5') }}</span>
                </a>
                <a
                  :href="getActualUrl('/templates_type_6.xlsx')"
                  download="тип_6.xlsx"
                  class="mt-4 d-flex align-center file-link"
                  @click.prevent="openInstructionsInNewTab('/templates_type_6.xlsx')"
                >
                  <v-icon
                    size="18"
                    class="mr-1"
                    >mdi-link-variant</v-icon
                  >
                  <span>{{ $t('header.templatesType6') }}</span>
                </a>
              </div>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </template>

      <template #modal-footer>
        <v-btn
          text
          class="custom-button_lightGrey ml-auto"
          @click="isOpenedInstructions = false"
        >
          {{ $t('common.btn.ok') }}
        </v-btn>
      </template>
    </DialogModal>
  </header>
</template>

<script>
import Sidebar from '@/components/header/components/Sidebar.vue'
import DialogModal from '@/components/ui/DialogModal.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { getSessionStorageKey, setSessionStorageKey } from '@/scripts/sessionStorage'

export default {
  name: 'index',

  components: {
    Sidebar,
    DialogModal
  },

  props: {
    isLoggedIn: Boolean
  },

  created() {
    if (!getSessionStorageKey('locale')) {
      setSessionStorageKey('locale', 'ru')
    }
    this.setLocale(getSessionStorageKey('locale'))
  },

  data: () => ({
    drawer: false,
    isGetCurrentUser: false,
    openMenu: false,
    isOpenedInstructions: false,
    tab: null
  }),

  computed: {
    ...mapState('user', ['currentUser']),
    ...mapGetters('user', [
      'studentRole',
      'userName',
      'studentRole',
      'editorClassroomsRole',
      'editorTeachersRole',
      'editorScheduleRole',
      'adminRole'
    ]),
    ...mapGetters('breakpoint', ['isXs']),
    ...mapGetters('locale', ['isRU'])
  },

  methods: {
    ...mapMutations('locale', ['setLocale']),

    async logout() {
      this.$emit('logout')
    },

    getActualUrl(url) {
      return `${url}?t=${Date.now()}`
    },

    openInstructionsInNewTab(url) {
      window.open(this.getActualUrl(url), '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: auto;
  width: 100%;
  //position: fixed;
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.02), 0px 0px 2px rgba(0, 0, 0, 0.05), 0px 1px 4px rgba(0, 0, 0, 0.08);
  background-color: white;
  z-index: 999;
}

.logo {
  max-width: 44px;
  max-height: 44px;
}

.header-text {
  line-height: 1.15;
  font-size: 18px;
}

.header-text-small {
  font-size: 12px;
}

.file-link {
  text-decoration: none;
  color: #6e6e6e;

  &:hover {
    color: rgb(24, 103, 192);
  }
}
</style>
